(function () {
  'use strict';

  const $ = (id) => document.getElementById(id);

  const els = {
    mass: $('massInput'),
    concInput: $('concInput'),
    concDown: $('concDown'),
    concUp: $('concUp'),
    count: $('countInput'),
    oilMass: $('oilMass'),
    waxMass: $('waxMass'),
    totals: $('totals'),
    totalOil: $('totalOil'),
    totalWax: $('totalWax'),
    fragSearch: $('fragSearch'),
    fragDD: $('fragDD'),
    productSearch: $('productSearch'),
    productDD: $('productDD'),
    clpStatus: $('clpStatus'),
    compareCard: $('compareCard'),
    compareTable: $('compareTable'),
    compareFootnotes: $('compareFootnotes'),
    kchCard: $('kchCard'),
    kchDownloads: $('kchDownloads'),
    fragCard: $('fragCard'),
    otherWarning: $('otherWarning'),
    otherWarningCta: $('otherWarningCta'),
    customSdsWarning: $('customSdsWarning'),
    customSdsText: $('customSdsText')
  };

  let LANG = 'pl';
  let MODE = 'topwosk';
  let selectedOilName = '';
  const PRODUCT_TYPES = [{ key: 'pt_candles', id: 'candles' }];
  let selectedProduct = PRODUCT_TYPES[0];

  const SUPPORTED_CONCS = [6, 8, 10];
  const PCN_COST_PL = 125;

  function assetUrl(key, fallback) {
    return (window.CALC_ASSETS && window.CALC_ASSETS[key]) || fallback;
  }

  function tr(key) {
    return (T[LANG] && T[LANG][key]) || T.pl[key] || key;
  }

  function formatTpl(str, vars) {
    return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : ''));
  }

  function applyTranslations() {
    document.documentElement.setAttribute('lang', LANG);
    document.querySelectorAll('[data-t]').forEach((el) => {
      el.innerHTML = tr(el.getAttribute('data-t'));
    });
    els.fragSearch.placeholder = tr('frag_placeholder');
    els.productSearch.value = tr(selectedProduct.key);
    document.querySelectorAll('.lang-btn').forEach((b) => {
      b.classList.toggle('active', b.dataset.lang === LANG);
    });
    calc();
  }

  const OIL_CATEGORIES = {
    'Owocowe': [
      'Ananas i Kokos','Arbuz','Cashmere plum','Dzika Wiśnia','Mango',
      'Owoce Lasu','Pink Lemonade Spritz','Pomarańcza','Słodka Mandarynka',
      'Kokos','Truskawka','Zielone Jabłko','Raspberry Reverie'
    ],
    'Kwiatowe': [
      'Frezja','Goddess girl','Lawenda','Rose Lady','Rose petals white peach',
      'Róża','Sól morska i orchidea','Velvet Violet','Verbena orange blossom','Black Orchid & Amber','Kwiat Bzu','Dobry Sen'
    ],
    'Słodkie / Deserowe': [
      'Almond Macaron','Apple Crumble Cookies','Bourbon Vanillia','Brown sugar nad fig',
      'Caramel popcorn','Ciasteczka','Cookies strawberry crumble','Gingerbread',
      'Czekolada i ziarna kakaowe','Shea Butter Honey','Sweet pumpkin','Wanilia','Bubblegum Ballon','Karmelowe Jabłko'
    ],
    'Korzenne / Orientalne': [
      'Apple - Cinnamon','Cynamon','Mulled wine toddy','Orange spices',
      'Pomarańcza - Cynamon','Black Cardamon and Cream','Kadzidło i Mirra','Wieczór Wigilijny'
    ],
    'Świeże / Zielone': [
      'California dreaming','Czysta bawełna','Green Tea','Happy life',
      'Lemon and mint','Matcha and bergamot','Nordic fir firewood',
      'Warm summer breeze','White Sage','Calamansi & Coriander','Citronella','Kwiat Konopi','Matcha Tea & Wild Honey','Świeża Pościel'
    ],
    'Drzewne / Męskie': [
      'Bergamot Patchouli','Cedarwood Vanilla','Drzewo sandałowe',
      'Gentle Masculine','High class dark musk',
      'Palo santo and sandalwood','Palo santo vibe','Rich amber','Velvet tobacco','Gabinet Dżentelmena','Toskańska Skóra'
    ],
    'Inne': [
      'Angelic Fantasy','Gin Tonic','Kawa','Niezwykły'
    ]
  };

  function normalizeName(name) {
    return (name || '').toLowerCase().replace(/[\s\-]+/g, '');
  }

  function fmt(n) {
    const s = n.toFixed(1);
    return LANG === 'pl' ? s.replace('.', ',') : s;
  }

  function fmtConc(c) {
    let s = c.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    return LANG === 'pl' ? s.replace('.', ',') : s;
  }

  function getMass() {
    const v = parseFloat(els.mass.value);
    return isFinite(v) && v > 0 ? v : 0;
  }

  function getConc() {
    const v = parseFloat(els.concInput.value);
    return isFinite(v) && v > 0 ? v : 0;
  }

  function getCount() {
    const v = parseInt(els.count.value, 10);
    return isFinite(v) && v > 0 ? v : 1;
  }

  function calc() {
    const mass = getMass();
    const conc = getConc();
    const count = getCount();

    const oil = mass * (conc / 100);
    const wax = mass - oil;

    els.oilMass.textContent = fmt(oil);
    els.waxMass.textContent = fmt(wax);

    if (count > 1) {
      els.totals.hidden = false;
      els.totalOil.textContent = fmt(oil * count);
      els.totalWax.textContent = fmt(wax * count);
    } else {
      els.totals.hidden = true;
    }

    updateClp();
    updateCompare();
    updateKch();
    updateOtherWarning();
    updateCustomSdsWarning();
  }

  function updateCustomSdsWarning() {
    if (MODE !== 'topwosk' || !selectedOilName || !DB[selectedOilName]) {
      els.customSdsWarning.hidden = true;
      return;
    }
    const conc = getConc();
    const bucket = bucketConc(conc);
    if (bucket === null) {
      els.customSdsWarning.hidden = true;
      return;
    }
    if (SUPPORTED_CONCS.indexOf(conc) !== -1) {
      els.customSdsWarning.hidden = true;
      return;
    }
    els.customSdsWarning.hidden = false;
    els.customSdsText.innerHTML = formatTpl(tr('clp_custom_sds_text'), {
      conc: fmtConc(conc),
      bucket: bucket
    });
  }

  function setMode(m) {
    if (m !== 'topwosk' && m !== 'other') return;
    MODE = m;
    document.querySelectorAll('.mode-btn').forEach((b) => {
      b.classList.toggle('active', b.dataset.mode === m);
    });
    els.fragCard.hidden = (m !== 'topwosk');
    if (m === 'other') {
      selectedOilName = '';
      els.fragSearch.value = '';
      els.fragDD.classList.remove('open');
    }
    calc();
  }

  function updateOtherWarning() {
    if (MODE === 'other') {
      els.otherWarning.hidden = false;
      els.otherWarningCta.setAttribute('href', assetUrl('oilsUrl', 'https://topwosk.pl/collections/zapachy-do-swiec'));
    } else {
      els.otherWarning.hidden = true;
    }
  }

  function normKch(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ł/g, 'l')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function findKchFile(fragName, conc, lang) {
    if (!fragName || !conc || typeof KCH_FILES === 'undefined') return null;
    const searchLang = lang === 'pl' ? 'pl' : 'en';
    const target = normKch(fragName) + conc + searchLang;
    for (const f of KCH_FILES) {
      const n = normKch(f);
      if (n.endsWith('pdf') && n.includes(target)) return f;
    }
    return null;
  }

  const KCH_CACHE_BUST = '20261016b';

  function downloadKch(file) {
    if (!file) return;
    const conc = parseFloat(els.concInput.value) || 0;
    const mass = parseFloat(els.mass.value) || 0;
    const count = parseInt(els.count.value, 10) || 0;
    TWAnalytics.track('tw_calc_kch_downloaded', {
      oil_name: selectedOilName,
      concentration: conc,
      mass_g: mass,
      count: count,
      file: file,
      language: LANG
    });
    let base = (window.CALC_ASSETS && window.CALC_ASSETS.kchBase) || 'assets/kch/';
    if (base && !base.endsWith('/')) base += '/';
    // Cache-buster for the Shopify CDN: PDFs replaced under the same filename stay cached
    // for up to a year under the bare URL. Bump KCH_CACHE_BUST whenever any KCH PDF is re-uploaded.
    const bust = /^(https?:)?\/\//.test(base) ? '?v=' + KCH_CACHE_BUST : '';
    window.open(base + encodeURIComponent(file) + bust, '_blank');
  }

  function updateKch() {
    if (MODE !== 'topwosk') {
      els.kchCard.hidden = true;
      return;
    }
    const name = selectedOilName;
    if (!name) {
      els.kchCard.hidden = true;
      return;
    }
    const conc = getConc();
    if (SUPPORTED_CONCS.indexOf(conc) === -1) {
      els.kchCard.hidden = true;
      return;
    }
    const file = findKchFile(name, conc, LANG);
    if (!file) {
      els.kchCard.hidden = true;
      return;
    }
    els.kchCard.hidden = false;
    const fileEsc = escapeHtml(file);
    els.kchDownloads.innerHTML = `<button type="button" class="kch-btn" data-file="${file.replace(/"/g, '&quot;')}">
      <span class="kch-conc">${conc}%</span>
      <span class="kch-filename">${fileEsc}</span>
      <span class="kch-label">${tr('kch_download')}</span>
    </button>`;
    const btn = els.kchDownloads.querySelector('.kch-btn[data-file]');
    if (btn) btn.addEventListener('click', () => downloadKch(btn.dataset.file));
  }

  function findOilData(name, conc) {
    const oil = DB[name];
    if (!oil || !oil.conc || !oil.conc[conc]) return null;
    return oil.conc[conc][LANG] || oil.conc[conc].pl || null;
  }

  function oilMarkerLevel(name) {
    const oil = DB[name];
    if (!oil || !oil.conc) return 'clean';
    let hasBad = false;
    let hasLabel = false;
    for (const c of SUPPORTED_CONCS) {
      const data = oil.conc[c] && (oil.conc[c][LANG] || oil.conc[c].pl);
      if (!data) continue;
      const scenario = classifyScenario(data);
      if (scenario === 'bad') { hasBad = true; break; }
      if (scenario === 'euh208_only' || scenario === 'env_only') hasLabel = true;
    }
    if (hasBad) return 'pcn';
    if (hasLabel) return 'euh208';
    return 'clean';
  }

  function buildDropdown(query) {
    const dd = els.fragDD;
    dd.innerHTML = '';
    const q = (query || '').toLowerCase().trim();

    if (document.activeElement !== els.fragSearch) {
      dd.classList.remove('open');
      return;
    }

    const dbNames = Object.keys(DB);
    const normToDbName = new Map();
    for (const n of dbNames) normToDbName.set(normalizeName(n), n);

    let hasItems = false;
    let selectedEl = null;
    const usedNorms = new Set();

    const renderCategory = (catKey, oilNames) => {
      const filtered = oilNames
        .filter((n) => !q || n.toLowerCase().includes(q))
        .sort((a, b) => a.localeCompare(b, 'pl'));
      if (!filtered.length) return;

      const header = document.createElement('div');
      header.className = 'dd-cat';
      header.textContent = tr('cat_' + catKey);
      dd.appendChild(header);

      for (const name of filtered) {
        const item = document.createElement('div');
        item.className = 'dd-item' + (name === selectedOilName ? ' selected' : '');
        const level = oilMarkerLevel(name);
        const nameSpan = document.createElement('span');
        nameSpan.className = 'dd-item-name';
        nameSpan.textContent = name;
        item.appendChild(nameSpan);
        if (level !== 'clean') {
          const badge = document.createElement('span');
          badge.className = 'dd-badge dd-badge--' + level;
          badge.textContent = level === 'pcn' ? 'PCN' : 'EUH208';
          badge.title = tr(level === 'pcn' ? 'badge_pcn_tooltip' : 'badge_euh208_tooltip');
          item.appendChild(badge);
        }
        item.addEventListener('mousedown', (e) => {
          e.preventDefault();
          selectOil(name);
        });
        dd.appendChild(item);
        if (name === selectedOilName) selectedEl = item;
        hasItems = true;
      }
    };

    for (const cat of Object.keys(OIL_CATEGORIES)) {
      const mapped = [];
      for (const srcName of OIL_CATEGORIES[cat]) {
        const norm = normalizeName(srcName);
        const dbName = normToDbName.get(norm);
        if (dbName) {
          mapped.push(dbName);
          usedNorms.add(norm);
        }
      }
      renderCategory(cat, mapped);
    }

    const leftovers = dbNames.filter((n) => !usedNorms.has(normalizeName(n)));
    if (leftovers.length) renderCategory('Pozostałe', leftovers);

    if (hasItems) dd.classList.add('open');
    else {
      dd.classList.remove('open');
      const empty = document.createElement('div');
      empty.className = 'dd-empty';
      empty.textContent = tr('dd_empty');
      dd.appendChild(empty);
      dd.classList.add('open');
    }
    if (selectedEl) selectedEl.scrollIntoView({ block: 'center' });
  }

  function selectOil(name) {
    selectedOilName = name;
    els.fragSearch.value = name;
    els.fragDD.classList.remove('open');
    calc();
    TWAnalytics.track('tw_calc_oil_selected', { oil_name: name, language: LANG });
  }

  function buildProductDropdown() {
    const dd = els.productDD;
    dd.innerHTML = '';
    for (const pt of PRODUCT_TYPES) {
      const item = document.createElement('div');
      item.className = 'dd-item' + (pt.id === selectedProduct.id ? ' selected' : '');
      item.textContent = tr(pt.key);
      item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        selectedProduct = pt;
        els.productSearch.value = tr(pt.key);
        dd.classList.remove('open');
      });
      dd.appendChild(item);
    }
    dd.classList.add('open');
  }

  const PICTO_KEYS = {
    exclamation: 'picto_exclamation',
    health: 'picto_health',
    environment: 'picto_environment',
    flame: 'picto_flame',
    corrosion: 'picto_corrosion',
    oxidizer: 'picto_oxidizer'
  };

  const PICTO_SHORT = {
    exclamation: 'GHS07',
    health: 'GHS08',
    environment: 'GHS09',
    flame: 'GHS02',
    corrosion: 'GHS05',
    oxidizer: 'GHS03'
  };

  function pictoList(pictos) {
    if (!pictos || !pictos.length) return tr('picto_none');
    return pictos.map((p) => tr(PICTO_KEYS[p]) || p).join(', ');
  }

  function signalLabel(signal) {
    if (signal === 'danger') return tr('signal_danger');
    if (signal === 'warning') return tr('signal_warning');
    return signal || '';
  }

  function classifyScenario(data) {
    if (!data) return 'clean';
    const hasH = (data.h || '').trim().length > 0;
    const hasContains = (data.contains || '').trim().length > 0;
    if (!hasH) {
      return hasContains ? 'euh208_only' : 'clean';
    }
    const healthPictos = (data.pictos || []).filter((p) => p !== 'environment');
    if (healthPictos.length === 0) return 'env_only';
    return 'bad';
  }

  function bucketConc(conc) {
    if (!isFinite(conc) || conc <= 0) return null;
    if (conc <= 6) return 6;
    if (conc <= 8) return 8;
    if (conc <= 10) return 10;
    return null;
  }

  function buildStatus(scenario, name, conc, bucket, data) {
    const ok = '✓';
    const warn = '!';
    const bad = '✗';

    if (scenario === 'above_limit') {
      return `
        <span class="clp-badge">${tr('clp_above_limit')}</span>
        <p class="clp-text">${tr('clp_above_limit_text')}</p>
      `;
    }

    if (scenario === 'clean') {
      return `
        <span class="clp-badge">${tr('clp_none')}</span>
        <p class="clp-text">${formatTpl(tr('clp_clean_text'), { conc: fmtConc(conc), name: name })}</p>
        <ul class="clp-list">
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_picto')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_ufi')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_pcn')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_cost')}</li>
        </ul>
      `;
    }
    if (scenario === 'euh208_only') {
      return `
        <span class="clp-badge">${tr('clp_euh208')}</span>
        <p class="clp-text">${formatTpl(tr('clp_euh208_text'), { conc: fmtConc(conc), name: name })}</p>
        <p class="clp-contains">${tr('clp_contains_label')}: ${escapeHtml(data.contains)}</p>
        <ul class="clp-list">
          <li class="no"><span class="mark">${warn}</span> ${tr('clp_li_euh208_required')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_picto')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_ufi')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_pcn')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_cost')}</li>
        </ul>
      `;
    }
    const containsHtml = (data.contains || '').trim().length > 0
      ? `<p class="clp-contains">${tr('clp_contains_label')}: ${escapeHtml(data.contains)}</p>`
      : '';
    if (scenario === 'env_only') {
      const hasEnvPicto = (data.pictos || []).indexOf('environment') !== -1;
      const pictoLi = hasEnvPicto
        ? `<li class="no"><span class="mark">${warn}</span> ${formatTpl(tr('clp_li_env_picto'), { pictos: pictoList(data.pictos) })}</li>`
        : `<li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_picto')}</li>`;
      return `
        <span class="clp-badge">${tr('clp_env')}</span>
        <p class="clp-text">${formatTpl(tr('clp_env_text'), { conc: fmtConc(conc), name: name })}</p>
        <p class="clp-h">${tr('clp_h_label')}: ${escapeHtml(data.h)}</p>
        ${containsHtml}
        <ul class="clp-list">
          ${pictoLi}
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_env_no_ufi')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_env_no_pcn')}</li>
          <li class="yes"><span class="mark">${ok}</span> ${tr('clp_li_no_cost')}</li>
        </ul>
      `;
    }
    const signalHtml = data.signal
      ? `<li class="no"><span class="mark">${bad}</span> ${formatTpl(tr('clp_li_bad_signal'), { signal: signalLabel(data.signal) })}</li>`
      : '';
    return `
      <span class="clp-badge">${tr('clp_full')}</span>
      <p class="clp-text">${formatTpl(tr('clp_bad_text'), { conc: fmtConc(conc), name: name })}</p>
      <p class="clp-h">${tr('clp_h_label')}: ${escapeHtml(data.h)}</p>
      ${containsHtml}
      <ul class="clp-list">
        <li class="no"><span class="mark">${bad}</span> ${formatTpl(tr('clp_li_bad_picto'), { pictos: pictoList(data.pictos) })}</li>
        ${signalHtml}
        <li class="no"><span class="mark">${bad}</span> ${tr('clp_li_bad_ufi')}</li>
        <li class="no"><span class="mark">${bad}</span> ${formatTpl(tr('clp_li_bad_pcn'), { cost: PCN_COST_PL })}</li>
      </ul>
    `;
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function updateClp() {
    if (MODE !== 'topwosk') {
      els.clpStatus.hidden = true;
      return;
    }
    const name = selectedOilName;
    if (!name || !DB[name]) {
      els.clpStatus.hidden = true;
      return;
    }

    const conc = getConc();
    const bucket = bucketConc(conc);
    let scenario;
    let data = null;

    if (bucket === null) {
      scenario = 'above_limit';
    } else {
      data = findOilData(name, bucket);
      scenario = classifyScenario(data);
    }

    els.clpStatus.hidden = false;
    const cls = scenario === 'bad' ? 'bad'
              : scenario === 'env_only' ? 'warn'
              : scenario === 'euh208_only' ? 'warn'
              : scenario === 'above_limit' ? 'warn'
              : 'ok';
    els.clpStatus.className = 'clp-status ' + cls;
    els.clpStatus.innerHTML = buildStatus(scenario, name, conc, bucket, data);
  }

  function updateCompare() {
    if (MODE !== 'topwosk') {
      els.compareCard.hidden = true;
      return;
    }
    const name = selectedOilName;
    if (!name || !DB[name]) {
      els.compareCard.hidden = true;
      return;
    }
    const mass = getMass();
    if (!mass) {
      els.compareCard.hidden = true;
      return;
    }

    const unitG = tr('suffix_g');
    const costNone = LANG === 'pl' ? '0 zł' : '0 PLN';
    const costFull = LANG === 'pl' ? `${PCN_COST_PL} zł` : `${PCN_COST_PL} PLN`;

    const pictoShort = (p) => {
      if (!p || !p.length) return tr('val_none');
      return p.map((x) => PICTO_SHORT[x] || x).join(', ');
    };

    let hasPcn = false;
    let hasEuh = false;

    const rowFor = (c) => {
      const data = findOilData(name, c);
      const scenario = classifyScenario(data);
      if (scenario === 'clean') {
        return { label: tr('clp_none'), cls: 'cell-ok', picto: tr('val_none'), ufi: tr('val_no'), pcn: tr('val_no'), cost: costNone, fn: '' };
      }
      if (scenario === 'euh208_only') {
        hasEuh = true;
        return { label: tr('clp_euh208'), cls: 'cell-warn', picto: tr('val_none'), ufi: tr('val_no'), pcn: tr('val_no'), cost: costNone, fn: '*' };
      }
      if (scenario === 'env_only') {
        return { label: tr('clp_env'), cls: 'cell-warn', picto: pictoShort(data.pictos), ufi: tr('val_no'), pcn: tr('val_no'), cost: costNone, fn: '' };
      }
      hasPcn = true;
      return { label: tr('val_classified'), cls: 'cell-bad', picto: pictoShort(data.pictos), ufi: tr('val_yes'), pcn: tr('val_yes'), cost: costFull, fn: '**' };
    };

    const data = SUPPORTED_CONCS.map((c) => ({ c, r: rowFor(c), g: mass * (c / 100) }));

    const rowsHtml = `
      <tr><td>${tr('tbl_oil_mass')}</td>${data.map((d) => `<td>${fmt(d.g)} ${unitG}</td>`).join('')}</tr>
      <tr><td>${tr('tbl_classification')}</td>${data.map((d) => `<td class="${d.r.cls}">${d.r.label}</td>`).join('')}</tr>
      <tr><td>${tr('tbl_pictos')}</td>${data.map((d) => `<td>${d.r.picto}</td>`).join('')}</tr>
      <tr><td>${tr('tbl_ufi')}</td>${data.map((d) => `<td>${d.r.ufi}</td>`).join('')}</tr>
      <tr><td>${tr('tbl_pcn')}</td>${data.map((d) => `<td>${d.r.pcn}</td>`).join('')}</tr>
      <tr><td>${tr('tbl_cost')}</td>${data.map((d) => `<td>${d.r.cost}<sup class="fn-ref">${d.r.fn}</sup></td>`).join('')}</tr>
    `;

    els.compareCard.hidden = false;
    els.compareTable.querySelector('tbody').innerHTML = rowsHtml;

    const labelUrl = assetUrl('labelUrl', 'https://topwosk.pl/pages/generator-etykiet-clp');
    const notes = [];
    notes.push(`<p class="compare-note">${formatTpl(tr('compare_note_always'), { labelUrl })}</p>`);
    if (hasEuh) notes.push(`<p class="compare-note">${formatTpl(tr('compare_note_euh208'), { labelUrl })}</p>`);
    if (hasPcn) notes.push(`<p class="compare-note">${tr('compare_note_pcn')}</p>`);
    els.compareFootnotes.innerHTML = notes.join('');
  }

  function clampConc(v) {
    if (!isFinite(v)) return 0.25;
    v = Math.round(v * 4) / 4;
    return Math.max(0.25, Math.min(30, v));
  }

  function setConc(v) {
    v = clampConc(v);
    els.concInput.value = v;
    updateChips(v);
    calc();
  }

  function updateChips(v) {
    document.querySelectorAll('.chip').forEach((c) => {
      c.classList.toggle('active', parseFloat(c.dataset.conc) === v);
    });
  }

  function onConcInput() {
    const v = parseFloat(els.concInput.value);
    if (!isFinite(v)) return;
    updateChips(v);
    calc();
  }

  function bind() {
    els.mass.addEventListener('input', calc);
    els.concInput.addEventListener('input', onConcInput);
    els.concDown.addEventListener('click', () => {
      setConc((parseFloat(els.concInput.value) || 0) - 0.25);
    });
    els.concUp.addEventListener('click', () => {
      setConc((parseFloat(els.concInput.value) || 0) + 0.25);
    });
    document.querySelectorAll('.chip').forEach((c) => {
      c.addEventListener('click', () => setConc(parseFloat(c.dataset.conc)));
    });
    els.count.addEventListener('input', calc);
    els.fragSearch.addEventListener('input', () => buildDropdown(els.fragSearch.value));
    els.fragSearch.addEventListener('focus', () => {
      els.fragSearch.select();
      buildDropdown('');
    });
    els.productSearch.addEventListener('focus', buildProductDropdown);
    els.productSearch.addEventListener('click', buildProductDropdown);
    document.querySelectorAll('.lang-btn').forEach((b) => {
      b.addEventListener('click', () => {
        LANG = b.dataset.lang;
        applyTranslations();
        TWAnalytics.track('tw_calc_lang_switched', { language: LANG });
      });
    });
    document.querySelectorAll('.mode-btn').forEach((b) => {
      b.addEventListener('click', () => {
        setMode(b.dataset.mode);
        TWAnalytics.track('tw_calc_mode_switched', { mode: b.dataset.mode });
      });
    });
    els.otherWarningCta.addEventListener('click', () => {
      TWAnalytics.track('tw_calc_oils_cta_clicked', { source: 'other_warning', language: LANG });
    });
    els.compareFootnotes.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (a && /generator-etykiet-clp/.test(a.getAttribute('href') || '')) {
        TWAnalytics.track('tw_calc_label_cta_clicked', { source: 'compare_note', language: LANG });
      }
    });
    document.addEventListener('click', (e) => {
      const wrap = e.target.closest('.search-wrap');
      if (!wrap || !wrap.contains(els.fragSearch)) els.fragDD.classList.remove('open');
      if (!wrap || !wrap.contains(els.productSearch)) els.productDD.classList.remove('open');
    });
  }

  bind();
  applyTranslations();
  updateChips(parseFloat(els.concInput.value) || 8);
  TWAnalytics.track('tw_calc_loaded', { language: LANG, mode: MODE });
})();
